import React from 'react'
import Registrations from '../Pages/Registration/NriRegistration'

function Registration() {
  return (
    <div>
      <Registrations/>
    </div>
  )
}

export default Registration